import { toast as sonner, Toaster as SonnerToaster } from 'sonner';
import { errorMessage, requestIdOf } from '@/i18n/errors';

export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      gap={10}
      offset={20}
      toastOptions={{
        classNames: {
          toast:
            '!rounded-xl !border !border-line !bg-surface-0 !text-ink-900 !shadow-e3 !font-sans !text-[13.5px] !gap-3',
          title: '!font-semibold',
          description: '!text-ink-500',
          success: '[&_[data-icon]]:!text-jade-600',
          error: '[&_[data-icon]]:!text-danger-600',
          actionButton: '!bg-ink-900 !text-white !rounded-lg',
        },
      }}
    />
  );
}

export const toast = {
  success: (title: string, description?: string) => sonner.success(title, { description }),
  info: (title: string, description?: string) => sonner(title, { description }),
  /** Error toast with the support code (requestId) to copy, when the server gave one. */
  error: (error: unknown, title?: string) => {
    const message = errorMessage(error);
    if (!message) return;
    const requestId = requestIdOf(error);
    sonner.error(title ?? message, {
      description: title ? message : requestId ? `Código de soporte: ${requestId}` : undefined,
      action: requestId
        ? { label: 'Copiar código', onClick: () => void navigator.clipboard?.writeText(requestId) }
        : undefined,
    });
  },
  promise: sonner.promise,
};
